import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import CompositeItemImage from '../../CompositeItemImage';
import CartUpsellInfo from '../../../features/cart/CartItem/original/CartUpsellInfo';
import axios from 'axios';
import LoadingSpinner from '@/components/tailwind/LoadingSpinner';
import WebImage from '@components/tailwind/WebImage';

export type CartItemInfo = {
  bundleItems: any;
  imageUrl: string;
  displayName: string;
  rateFormatted: string;
  quantity: number;
  id: number;
};

type Props = {
  item: CartItemInfo;
  className?: '';
};

const AddedToCartModalItem = ({ item, className = '' }) => {
  const [processing, setProcessing] = useState(false);
  const [images, setImages] = useState(null);

  const { designId } = item;
  useEffect(() => {
    if (designId) {
      setProcessing(true);
      setTimeout(async () => {
        const { data } = await axios.get(
          jsRoutes.controllers.Customization.userDesignPreview(designId, 'previewProduct').url
        );
        if (!!data) {
          setImages(data.filter((d) => d.face !== 'all'));
        }
        setProcessing(false);
      }, 0);
    }
  }, [designId]);

  return (
    <div className={classNames('tw:flex tw:px-0 tw:py-3', className)}>
      <div className='tw:w-1/3 tw:shrink-0 tw:grow-0 tw:basis-1/3 tw:p-1'>
        {item.isBundle ? (
          <CompositeItemImage
            sources={item.bundleItems}
            primaryHeight={Boolean(item.bundleItems?.[0]?.graphicType) ? 150 : 100}
            secondaryHeight={85}
            fullHeight={false}
          />
        ) : images ? (
          images.map((image, i) => (
            <img
              key={i}
              src={image.url}
              alt={item.displayName}
              className='tw:mx-auto tw:max-h-[120px] tw:max-w-full'
            />
          ))
        ) : (
          <WebImage
            webImage={item.webImages.default.thumb}
            alt={item.displayName}
            className='tw:max-h-[120px] tw:max-w-full'
          />
        )}
        {processing && <LoadingSpinner inline={true} small={true} />}
      </div>
      <div className='tw:p-1'>
        <p className='tw:mb-2 tw:text-base tw:font-bold'>{item.displayName}</p>
        {item?.isUpsell && !!item?.upsellDetails?.percentOff && (
          <CartUpsellInfo percentOff={item.upsellDetails.percentOff} />
        )}
        <p className='tw:mb-0 tw:text-sm tw:font-bold'>{item.rateFormatted}</p>
        <p className='tw:mb-0 tw:text-sm tw:font-bold'>Quantity: {item.quantity}</p>
      </div>
    </div>
  );
};

export default AddedToCartModalItem;
